/* eslint-disable no-eval */
import axios from 'axios';
import moment from 'moment';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
  UrlBase,
  URL_PLUGIN,
  URL_PLUGIN_FRONTEND,
  URL_PLUGIN_PROD,
  URL_PLUGIN_SEGUROS,
} from 'src/parametros';
import useInputsResources from 'src/reducers/InputsResources/useInputsResources';
import * as urls from 'src/services/urls';
import * as validaciones from 'src/utils/validaciones';
import validator from 'validator';
import useCustomToast from './useCustomToast';
import publicIp from 'public-ip';

const validators = {
  isCedula: (value) => {
    if (!validaciones.validarRuc(value) || value.length !== 10) {
      return false;
    }
    return true;
  },
  isRuc: (value) => {
    if (
      validaciones.validarRuc(value) &&
      value.length === 13 &&
      (value.endsWith('001') || value.endsWith('002') || value.endsWith('003'))
    ) {
      return true;
    } else return false;
  },
  ...validaciones,
};

const useProcessRules = (input) => {
  const [loading, setLoading] = useState(false);
  const methods = useFormContext();
  const toasts = useCustomToast();
  const inputsResources = useInputsResources();
  // const { isSubmitting,isSubmitted,isSubmitSuccessful } = useFormState(methods?.control);
  const { cotizacion, beneficiarios }: any = useSelector<any>((state) => ({
    cotizacion: state?.Cotizacion?.cotizacion,
    beneficiarios: state?.Cotizacion?.cotizacion?.beneficiarios || [],
  }));

  const processValidations = (extraProps = {}) => {
    if (input.customValidation) {
      const isB64 = validator.isBase64(input.customValidation);
      let strValidation = input.customValidation;
      if (isB64) {
        // strValidation = window.atob(unescape(encodeURIComponent(input.customValidation)));
        strValidation = window.atob(input.customValidation);
        // strValidation = decodeURIComponent(escape(window.atob(input.customValidation)));
      }

      const myValidation = eval(strValidation);
      input.rules.validate = {
        custom: async (value) => {
          return await myValidation(value, methods, beneficiarios, {
            axios,
            moment,
            validators,
            validator,
            cotizacion,
            React,
            toasts,
            input,
            DATE_FORMAT: 'DD/MM/yyyy',
            inputsResources,
            publicIp,
            urls: {
              URL_PLUGIN,
              URL_PLUGIN_PROD,
              URL_PLUGIN_FRONTEND,
              URL_PLUGIN_SEGUROS,
              UrlBase,
              ...urls,
            },
            loader: { isLoading: loading, setLoading },
            // submit:{ isSubmitting,isSubmitted,isSubmitSuccessful },
            ...extraProps,
          });
        },
      };
      /*
      input.rules.validate = async (value, event) => {
        return await myValidation(value, methods, beneficiarios, {
          axios,
          moment,
          validators,
          cotizacion,
          loader: { isLoading: loading, setLoading },
        });
      };
       */
      if (input?.longitud) {
        delete input?.longitud;
      }
      if (input?.rules?.pattern) {
        delete input?.rules?.pattern;
      }
    } else if (input.longitud) {
      input.length = parseInt(input.longitud);
    }
    if (input.type === 'desplegable') {
      console.log('RULES', input);
    }
    return input?.rules;
  };
  return { loading, setLoading, processValidations };
};

export default useProcessRules;
